import { Component, Input, Output, OnInit, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { AppService } from 'app/app.service';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { get } from 'lodash';
import { Subscription } from 'rxjs';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
export interface KuiTabBarTitleID {
    title: string;
    id: string;
    icon?: string;
    disabled?: boolean;
}

export interface KuiTabBarDragEvent {
    result: string[];
    id: string;
}

@Component({
    selector: 'kui-tab-bar',
    templateUrl: './tab-bar.component.html',
    standalone: false
})

export class KuiTabBarComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
    private dropSubscription: Subscription;
    _items: KuiTabBarTitleID[];

    @Input() items: Array<string | KuiTabBarTitleID>;
    @Input() mobile: boolean;
    @Input() selected: string | number;
    @Input() stretchItems: boolean;
    @Input() closeButton: boolean;
    @Input() draggable: boolean;

    @Output() selection = new EventEmitter<string>();
    @Output() reorder = new EventEmitter<KuiTabBarDragEvent>();
    @Output() close = new EventEmitter<string>();

    indicatorStyle = 'indicator-none';

    constructor(app: AppService) {
        super();

        this.on(app.theme$, theme => {
            this.indicatorStyle = 'indicator-' + get(theme.settings, 'tab.active.indicator.style', 'none');
        });
    }

    ngOnInit() {
        // Avoid ExpressionChangedAfterItHasBeenCheckedError by wrapping it in setTimeout
        setTimeout(() => {
            if (!this.selected && this.items.length > 0) {
                this.emitSelection(this._items[0]);
            }
        });

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.items) {
            this._items = (this.items || []).map((item) => {
                if (typeof item === 'string') {
                    return { title: item, id: item };
                }
                return item;
            });
        }
    }

    ngOnDestroy() {
        if (this.draggable && this.dropSubscription) {
            this.dropSubscription.unsubscribe();
        }
    }

    emitSelection(item: KuiTabBarTitleID) {
        if (!item.disabled) {
            this.selected = item.id;
            this.selection.emit(item.id);
        }
    }

    emitClose(item: KuiTabBarTitleID, e: Event) {
        e.stopPropagation();
        this.close.emit(item.id);
    }

    isSelected(item: KuiTabBarTitleID): boolean {
        return this.selected === item.id;
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this._items, event.previousIndex, event.currentIndex);
        this.reorder.emit({
            id: this._items[event.previousIndex].id,
            result: Array.from(this._items).map(item => item.id),
        });
    }
}
